export const RESPONSE_STATE = {
	SUCCESS: "Success",
	UNAUTHORIZED: "Unauthorized"
};
